var map = {
	"./image1.jpg": 488,
	"./image10.jpg": 80,
	"./image11.jpg": 681,
	"./image2.jpg": 415,
	"./image3.jpg": 700,
	"./image4.jpg": 401,
	"./image5.jpg": 640,
	"./image6.jpg": 280,
	"./image7.jpg": 986,
	"./image8.jpg": 301,
	"./image9.jpg": 302
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 749;